<template>
  <div class="v-progress">
    <span class="v-progress__bar" :style="{ width: progress + '%' }"></span>
  </div>
</template>

<script>
export default {
  name: "VProgressBar",
  props: {
    progress: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/variables";
.v-progress {
  height: 8px;
  position: relative;
  background: $color-lightgrey;
  border-radius: 0;
  padding: 0;
  &__bar {
    display: block;
    height: 100%;
    background-color: #004593;
    position: relative;
    overflow: hidden;
    transition: width 0.3s;
  }
}
</style>
